import { BinSelectionBypassReason } from "@redotech/redo-fulfillment-group-common/fulfillment-group-events";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const recordBinSelectionBypass = {
  name: "recordBinSelectionBypass" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(zExt.objectId()),
    reason: z.enum(BinSelectionBypassReason),
  }),
  output: z.object({ success: z.boolean() }),
};
